import ContactModalController from "./view/ContactModalController";
import ContactModalDirective from "./view/ContactModalDirective";

const ContactModalModule = angular
    .module("ContactModalModule", [])
    .controller("ContactModalController", ContactModalController)
    .directive("contactModal", ContactModalDirective);
export default ContactModalModule;
